"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTagCellFormatter = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
function TagCellFormatter(props) {
    if (props.tags.length > 0) {
        var tagsList = props.tags.join(', ');
        var count = react_1.default.createElement("span", null, Localize_1.Messages.TotalCount({ count: Localize_1.Formatters.formatCount(props.tags.length) }));
        return (react_1.default.createElement(data_catalog_shared_1.TextCellFormatter, { text: tagsList, useWidgetsTooltip: true, postIcon: count }));
    }
    else {
        return (react_1.default.createElement(data_catalog_shared_1.PlaceholderTextCell, { placeholderText: Localize_1.Messages.NoTagsAvailable() }));
    }
}
function createTagCellFormatter(getTagsFromRowData) {
    return function (props) { return (react_1.default.createElement(TagCellFormatter, { tags: getTagsFromRowData(props.row.data) })); };
}
exports.createTagCellFormatter = createTagCellFormatter;
//# sourceMappingURL=TagCellFormatter.js.map